export default __webpack_public_path__ + "static/media/logoLandscape.5f694e52.png";